import { render } from "./robot-archive.vue?vue&type=template&id=e6d56ee4&scoped=true"
import script from "./robot-archive.vue?vue&type=script&lang=js"
export * from "./robot-archive.vue?vue&type=script&lang=js"

import "./robot-archive.vue?vue&type=style&index=0&id=e6d56ee4&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6d56ee4"]])

export default __exports__